
  export default {
    props: { brand: { type: String, required: true } },
    computed: {
      brandImage () {
        return require(`~/assets/images/logos/banking/cards/${this.brand.toLowerCase()}.png`);
      }
    }
  };
